export default __webpack_public_path__ + "static/media/m-jobshub-04-v1.fd9c8589.jpg";